module.exports = __webpack_public_path__ + "imgs/Ispire.f31ccaef4ebdb78ac0d5d34a755a288e.png";